import { fromJS } from 'immutable'
import {
  MY_TIMESHEET_EXPORT_REQUEST,
  MY_TIMESHEET_EXPORT_SUCCESS,
  MY_TIMESHEET_EXPORT_FAILURE,
  MY_TIMESHEET_EXPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case MY_TIMESHEET_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case MY_TIMESHEET_EXPORT_SUCCESS:
      return state
        .set('url', fromJS(action.payload.url))
        .set('isFetching', false)
    case MY_TIMESHEET_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case MY_TIMESHEET_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/my-timesheet-export-reducer.js